/* External dependencies */
import { from, of } from 'rxjs';
import { catchError, debounceTime, filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { listUsersError, listUsersSuccess } from './action';
import { listUsersQuery } from './queries';
import { ListUsers, ListUsersAction, ListUsersActionTypes, ListUsersSuccess } from './types';

export default function listUsersEpic(action$, state$) {
  return action$.pipe(
    filter((action: ListUsersAction) => action.type === ListUsersActionTypes.LIST_USERS_REQUEST),
    debounceTime(800),
    switchMap((action: ListUsers) => from(listUsers(action)).pipe(catchError((error) => of(listUsersError(error))))),
  );
}

export async function listUsers({ input }: ListUsers): Promise<ListUsersSuccess> {
  const graphQLClient = await getClient();
  const { currentPage, query, filter, size } = input;
  const {
    data: {
      listUsers: { total, users },
    },
  } = await graphQLClient.query({
    query: listUsersQuery,
    variables: { input: { from: (currentPage - 1) * size, query, filter, size } },
  });

  return listUsersSuccess(total, users);
}
